<template>
  <div class="impact">
    <h4>
      ESTIMATED DEVELOPMENT IMPACT
    </h4>

    <div class="table">
      <div class="tbody">
        <div
          v-for="(row, rIdx) in rows"
          :key="rIdx"
          class="tr"
        >
          <div class="td">
            {{ row.label }}
          </div>

          <div class="td w-22 text-right">
            {{ formatCurrency(contentItem.rows[row.key], '') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useStringFormatter } from '@/composables';

const { formatCurrency } = useStringFormatter();

const props = defineProps({
  contentItem: {
    type: Object,
    required: true,
  },
});

const rows = [
  { key: 'householdNumber', label: 'Households that will benefit from this project' },
  { key: 'populationNumber', label: 'People in the district/metro who will benefit from this project' },
  { key: 'wypdNumber', label: 'Women, Youth and Persons with Disabilities (WYPD) who will benefit from this project' },
  { key: 'temporaryJobNumber', label: 'Temporary or construction jobs that will be created by this project' },
  { key: 'permanentJobNumber', label: 'Permanent jobs that will be created by this project' },
  { key: 'beneficiarySize', label: 'Beneficiary size (Level 3 community project specific)' },
];
</script>
